import { createReducer } from 'common/utils'
import { transformApiError } from 'common/api/errors'

export const INITIAL_STATE = {
  authHydrated: false,
  isAuthenticated: false,
  isFetching: false,
  user: undefined,
  error: null,
  permissions: []
}

const reducers = {
  'auth/LOGIN_REQUEST': loginRequest,
  'auth/LOGIN_SUCCESS': loginSuccess,
  'auth/LOGIN_FAILURE': loginFailure,
  'auth/AUTH_HYDRATED': authHydrated,
  'auth/FETCHED_PERMISSIONS': fetchedPermissions
}

function loginRequest (state) {
  return {
    ...state,
    loginFailed: false
  }
}

function loginSuccess (state, payload) {
  return {
    ...state,
    isAuthenticated: true,
    loginFailed: false,
    user: payload
  }
}

function fetchedPermissions (state, payload) {
  return {
    ...state,
    permissions: payload
  }
}

function loginFailure (state, error) {
  return {
    ...state,
    isAuthenticated: false,
    loginFailed: true,
    error: transformApiError(error).object()
  }
}

function authHydrated (state, payload) {
  return {
    ...state,
    authHydrated: true
  }
}

export default createReducer(INITIAL_STATE, reducers)
